import {Box} from "@mui/material";
import React from "react";

function ModalOverlay({handleClick, children}) {
    return (
        <Box
            onClick={handleClick}
            id="bg"
            sx={{
                position: "fixed",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(128, 128, 128, 0.5)", // Grey color with 50% opacity
                overflow: "auto",
                zIndex: 50, // Set an appropriate z-index value
            }}
        >
            { children }
        </Box>
    )
}

export default ModalOverlay;